import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/blog/orchestrator-protocol/page.tsx");
